import CustomIcon from "components/CustomIcon";
import Image from "next/image";
import { useDispatch } from "react-redux";
import { highlightMistakes, clearHighlight } from "lib/redux/highlightSlice";
import type { SectionType } from "lib/redux/highlightSlice";

export const PersonalPronouns = ({
  personalPronouns,
  section = "experience",
  itemIndex = null,
}: {
  personalPronouns: string[];
  section?: SectionType;
  itemIndex?: number | null;
}) => {
  const dispatch = useDispatch();

  // Handle hover on individual pronoun - use word-level highlighting
  const handlePronounMouseEnter = (pronoun: string) => {
    dispatch(
      highlightMistakes({
        section,
        itemIndex,
        mistakeType: "grammar", // Personal pronouns are grammar-related
        texts: [pronoun], // Highlight only this specific pronoun
      })
    );
  };

  const handleMouseLeave = () => {
    dispatch(clearHighlight());
  };
  return (
    <div className="relative mt-4 flex flex-col gap-[10px] rounded-xl bg-[#0F8D041C] px-[15px] py-[10px] md:mt-3 lg:gap-[16px] lg:px-[20px] lg:py-[14px]">
      <div className="absolute left-4 top-[-16px] flex items-center gap-2 rounded-xl bg-white px-4 py-2 font-bold text-black shadow-md lg:left-8 lg:px-6">
        <Image
          src="/icons/score-check/personalPronoun.svg"
          height={24}
          width={24}
          alt="icon"
          className="h-4 w-4 lg:h-5 lg:w-5"
        />
        <span className="text-sm font-bold lg:text-base xl:text-lg">
          Personal Pronouns Found
        </span>
      </div>
      <ul className="mt-4 px-[5px] md:mt-3">
        {personalPronouns.map((sent, idx) => (
          <li
            key={`${idx}`}
            className="lg:base my-[6px] flex w-full cursor-pointer items-center gap-2 rounded-lg bg-[#FDFDFD] p-2 pl-2 text-xs font-semibold text-[#B94444] transition-opacity hover:opacity-80 md:text-base lg:my-[10px] lg:gap-4 xl:pl-3"
            onMouseEnter={() => handlePronounMouseEnter(sent)}
            onMouseLeave={handleMouseLeave}
          >
            {/* <div className="h-auto w-auto">
              <CustomIcon iconName="cross" className="h-3 w-3 lg:h-4 lg:w-4" />
            </div> */}
            {sent}
          </li>
        ))}
      </ul>
      <div className="mt-4 flex flex-col items-center justify-center gap-3">
        <div className="relative h-32 w-32 lg:h-40 lg:w-40">
          <Image
            src="/assets/resumeScore/personalPronoun.png"
            alt="Personal pronouns illustration"
            fill
            className="object-contain"
          />
        </div>
        <p className="text-center text-sm font-semibold text-red-600 lg:text-base">
          Personal pronouns should be avoided in resumes.
        </p>
        {/* <p className="text-center text-xs text-gray-600 lg:text-sm">
          Avoid using personal pronouns to maintain a professional tone.
        </p> */}
      </div>
    </div>
  );
};
